
export interface SearchResultCard {
  id: string;
  name: string;
  number: string;
  rarity: string;
  supertype: string;
  subtypes: string[];
  images: {
    small: string;
    large: string;
  };
  setId: string;
  setName: string;
  setSeries: string;
  // allow other props
  [key: string]: any;
}

export const cardSearchService = {
  searchCards: async (query: string, limit: number = 20, offset: number = 0): Promise<{ cards: SearchResultCard[], total: number, hasMore: boolean }> => {
    if (!query || query.length < 2) return { cards: [], total: 0, hasMore: false };

    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/public/search?game=pokemon&q=${encodeURIComponent(query)}&limit=${limit}&offset=${offset}`);
        const data = await response.json();
        
        const cards = data.cards.map((card: any) => ({
            ...card,
            id: card.id,
            name: card.name,
            number: card.number,
            rarity: card.rarity,
            supertype: card.supertype,
            subtypes: card.subtypes,
            images: {
              small: card.thumbnailUrl || card.images?.small || '',
              large: card.imageUrl || card.images?.large || '',
            },
            setId: card.setId || card.set?.id,
            setName: card.setName || card.set?.name,
            setSeries: card.setSeries || card.set?.series,
        }));

        return {
            cards,
            total: data.total,
            hasMore: data.hasMore
        };
    } catch (error) {
        console.error('Pokemon backend search failed:', error);
        return { cards: [], total: 0, hasMore: false };
    }
  }
};
